/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 주행 콘텐츠 조회 응답
 */
export type GetEvBatteryManagementTripResponse = {
  /**
   * 업데이트 날짜 (형식: yyyyMMdd)
   */
  lastUpdatedDate: string;
  /**
   * 주행 횟수
   */
  tripCount: number;
  /**
   * 정속 주행 횟수
   */
  normalSpeedCount: number;
  /**
   * 고속 주행 횟수
   */
  highSpeedCount: number;
  /**
   * 고객 평균 정속 주행 횟수
   */
  avgNormalSpeedCount: number;
  /**
   * 고객 평균 고속 주행 횟수
   */
  avgHighSpeedCount: number;
  /**
   * 정속 주행 횟수
   */
  normalDrivingCount: number;
  /**
   * 급가감속 주행 횟수
   */
  harshDrivingCount: number;
  /**
   * 고객 평균 정속 주행 횟수 (급가감속 없는)
   */
  avgNormalDrivingCount: number;
  /**
   * 고객 평균 급가감속 주행 횟수
   */
  avgHarshDrivingCount: number;
  /**
   * 주행 정보 상태 (메시지 표출 시 참고)
   */
  tripStatus: GetEvBatteryManagementTripResponse.tripStatus;
  /**
   * 고속 주행 비율 상태 (메시지 표출 시 참고)
   */
  highSpeedRateStatus: GetEvBatteryManagementTripResponse.highSpeedRateStatus;
  /**
   * 급가속/급감속 주행 상태 (메시지 표출 시 참고)
   */
  harshDrivingRateStatus: GetEvBatteryManagementTripResponse.harshDrivingRateStatus;
};
export namespace GetEvBatteryManagementTripResponse {
  /**
   * 주행 정보 상태 (메시지 표출 시 참고)
   */
  export enum tripStatus {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
  }
  /**
   * 고속 주행 비율 상태 (메시지 표출 시 참고)
   */
  export enum highSpeedRateStatus {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
  }
  /**
   * 급가속/급감속 주행 상태 (메시지 표출 시 참고)
   */
  export enum harshDrivingRateStatus {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
  }
}

